<script>
import {BThead} from "bootstrap-vue";

export default {
  extends: BThead
};
</script>